import authRoles from '../../../auth/authRoles';
import About from './About';

const AboutConfig = {
  settings: {
    layout: {
      style: 'layoutMarketing',

      config: {
        header: {
          display: true
        },

        footer: {
          display: true
        }
      },
    },
  },

  auth: authRoles.onlyGuest,

  routes: [
    {
      path: '/about',
      element: <About />,
    },
  ],
};

export default AboutConfig;
